import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  useDisclosure,
  Image,
  Stack,
  Link
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

const ApiManual = () => {
  const { t } = useTranslation()
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Button
        size="sm"
        variant="outline"
        colorScheme="cyan"
        onClick={onOpen}
        w="100%"
      >
        {t('API 등록 방법 보기')}
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('API 키 등록 안내')}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Stack spacing={4}>
              <Text fontSize="sm" color="gray.600">
                {t(
                  'API 키 생성을 위해 먼저 Google OTP 등록과 펀드 비밀번호 설정이 필요합니다. 아래 보안 설정 페이지에서 등록해주세요.'
                )}
              </Text>

              <Link
                href="https://www.gate.com/myaccount/security-setting"
                color="cyan.500"
                fontWeight="bold"
                isExternal
              >
                {t('🔒 보안 설정 페이지 (Google OTP / 펀드 비밀번호)')}
              </Link>

              <Text fontSize="sm" color="gray.600">
                {t(
                  '아래 링크를 클릭해 Gate 거래소의 API 키 생성 페이지로 이동하세요.'
                )}
              </Text>

              <Link
                href="https://www.gate.com/myaccount/profile/api-key/save"
                color="cyan.500"
                fontWeight="bold"
                isExternal
              >
                {t('👉 Gate API 키 생성하러 가기')}
              </Link>

              <Image
                src="/images/manual.png"
                alt={t('API 키 생성 가이드 이미지') as string}
                borderRadius="md"
              />
            </Stack>
          </ModalBody>

          <ModalFooter>
            <Button onClick={onClose} colorScheme="gray">
              {t('닫기')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ApiManual
